import { Route } from 'react-router-dom'

//Utils
import { APP_URLS } from '../utils/urls'

export default function PatientRoutes() {
  return <Route path={APP_URLS.HOME} render={() => null} />
}
